export const GET_GAME_ASSETS_PENDING = 'GET_GAME_ASSETS_PENDING';
export const GET_GAME_ASSET_PENDING = 'GET_GAME_ASSET_PENDING';
export const CREATE_GAME_ASSET_PENDING = 'CREATE_GAME_ASSET_PENDING';
export const UPDATE_GAME_ASSET_PENDING = 'UPDATE_GAME_ASSET_PENDING';

export const GAME_ASSETS = 'SKILL_CONFIGS';
